import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type UpdateCollectionNameMutationVariables = Types.Exact<{
  collectionId: Types.Scalars['ID']['input'];
  name?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type UpdateCollectionNameMutation = { __typename?: 'Mutation', updateCollection?: { __typename?: 'UpdateCollectionPayload', collection?: { __typename?: 'Collection', id: string, name: string } | null } | null };


export const UpdateCollectionName = /*#__PURE__*/ gql`
    mutation UpdateCollectionName($collectionId: ID!, $name: String) {
  updateCollection(input: {collectionId: $collectionId, name: $name}) {
    collection {
      id
      name
    }
  }
}
    ` as unknown as DocumentNode<UpdateCollectionNameMutation, UpdateCollectionNameMutationVariables>;

          

          export const useUpdateCollectionNameMutation = (options?:MutationHookOptions<UpdateCollectionNameMutation, UpdateCollectionNameMutationVariables>) => useMutation(UpdateCollectionName, options);
          

          export type UpdateCollectionNameMutationOptions = MutationHookOptions<UpdateCollectionNameMutation, UpdateCollectionNameMutationVariables>;

          

          export type UpdateCollectionNameMutationResult = ReturnType<typeof useUpdateCollectionNameMutation>[1];

          
